import { createElement } from 'react';
import { isGamingWidgetActive, getLocale } from './isGamingWidgetActive';
import { createRootContainer } from './createGamingWidgetContainer';
import { GamingWidget } from '@sb/gaming-widget';
import { render } from '../../libs/ngsModuleLoader';

const getDomain = () => window.WH.sportsbook.sportsDomain;
const getConsole = () => window.consoleReference || window.console;

const getDataUrl = (locale) => {
    const dataFileName = `gamingWidget-${locale}.json`;
    return `https://${getDomain()}/data/homepage/${dataFileName}`;
};

export const renderGamingWidget = () => {
    if (!isGamingWidgetActive()) return;

    const container = createRootContainer();

    if (!container) {
        getConsole().warn('No container for Gaming Widget:');
        return;
    }

    const locale = getLocale();
    const dataUrl = getDataUrl(locale);

    render(container, { uiKit: true }, () => {
        return createElement(GamingWidget, {
            dataUrl,
        }, null);
    });
};
